<template>
	<div class="app">
		<div v-show="visible" class="contact">
			<div class="consult">
				<el-tooltip class="item" effect="dark" content="0791-88861315" placement="left">
					<div>
						<div class="icon">
							<img src="@/assets/images/phone.png" />
						</div>
						<div class="text">电话咨询</div>
					</div>
				</el-tooltip>
				<!-- <div class="line"></div> -->
				<!-- <el-tooltip class="item" effect="dark" content="079188861315" placement="left">
					<div>
						<div class="icon">
							<img src="@/assets/images/wechat.png" />
						</div>
						<div class="text">微信咨询</div>
					</div>
				</el-tooltip> -->
			</div>
			<div class="back-top">
				<div @click="backTop" class="box">
					<i style="color: #3087f8;font-size: 24px;" class="el-icon-arrow-up"></i>
				</div>
			</div>
		</div>
		<Header ref="headerRef" />
		<router-view :key="$route.fullPath"/>
		<Footer/>
	</div>
</template>

<script>
import Header from "@/layouts/header/Header";
import Footer from "@/layouts/footer/Footer";
export default {
	name: "App",
	components:{Header, Footer},
	data() {
		return {
			visible: false,
			headerRef: {},
		};
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
	methods: {
		handleScroll() {
			this.visible = window.scrollY > 300;
		},
		backTop() {
			this.$refs.headerRef.handleOpenHeader();
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	}
}
</script>

<style lang="scss" scoped>
.app {
	position: relative;
	width: 100%;
	cursor: default;
	display: flex;
	flex-direction: column;
	align-items: center;

	.contact {
		position: fixed;
		z-index: 100;
		bottom: 10%;
		right: 20px;
		width: 80px;
		color: #fff;
		font-size: 14px;

		.consult {
			width: 100%;
			padding: 15px 0;
			border-radius: 4px;
			background: linear-gradient( 180deg, #549EFF 0%, #1776F2 100%);
	
			.icon {
				display: flex;
				justify-content: center;
				img {
					width: 30px;
					height: 30px;
				}
			}

			.line {
				margin: 10px;
				height: 2px;
				background-color: #9ac4fc;
				border-radius: 1px;
			}

			.text {
				margin-top: 10px;
				text-align: center;
			}
		}

		.phone {
			border-bottom: 1px solid #fff;
		}

		.back-top {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 80px;
			margin-top: 10px;

			.box {
				width: 40px;
				height: 40px;
				border-radius: 40px;
				border: 1px solid #ebeef5;
				box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
				background-color: #fff;
				text-align: center;
				line-height: 40px;
				cursor: pointer;
			}
		}
	}
}
</style>
